// utils
import { HubspotStatus } from 'utils/hubspot/hubspotStatus';

export const checkHubspotStatus = (pointOfSale) => {
    return pointOfSale?.status_id === HubspotStatus.TRIAL_EXPIRED;
};
